import { Campaign } from '../../types';
import { ApiInstance } from '../instance';

export type CampaignPayload = {
  advertiser_id: string;
  name: string;
  objective: string;
  claim_type: string;
  daily_budget: string;
  total_budget?: string;
  start_at: Date;
  end_at?: Date | null;
};

export type CampaignsRequestPayload = {
  advertiser_id: string;
  start?: string;
  end?: string;
};

export const CampaignController = {
  getCampaignObjective: async () => {
    return await ApiInstance.get(`/advertisers/campaign-objective`);
  },
  getCampaigns: async (payload: CampaignsRequestPayload) => {
    return await ApiInstance.post(`/advertisers/campaigns`, payload);
  },
  getCampaign: async (payload: { id: string }) => {
    return await ApiInstance.get(
      `/advertisers/campaigns/${payload.id}`,
      // headers,
    );
  },
  updateCampaign: async (payload: { campaign_id: string, updated_data?: Partial<Campaign> }) => {
    return await ApiInstance.post(`/advertisers/campaigns/update`, payload);
  },
  createCampaign: async (payload: CampaignPayload) => {
    return await ApiInstance.post(`/advertisers/campaigns/create`, payload);
  },
  getQuestionsByClaimType: async (payload: { claim_id: string }) => {
    return await ApiInstance.post(`/advertisers/campaigns/get-questions`, payload);
  },
  uploadRetainerDocument: async (campaignId: string, file: File) => {
    const formData = new FormData();
    formData.append('document', file);
    return await ApiInstance.post(
      `/advertisers/campaigns/${campaignId}/retainer-document`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
  },
  getRetainerDocument: async (campaignId: string) => {
    return await ApiInstance.get(
      `/advertisers/campaigns/${campaignId}/retainer-document`,
    );
  },
  deleteRetainerDocument: async (campaignId: string) => {
    return await ApiInstance.delete(
      `/advertisers/campaigns/${campaignId}/retainer-document`,
    );
  },
};
